<template>
  <SwipeDialog title="医生选择" @closeFn="$emit('close')">
    <component
      :is="currentListComponent"
      style="padding-bottom: 44px"
      :on-select-item="handleSelectItem"
      :selected-items="selectedIdList"
    />
    <van-button
      type="info"
      block
      style="position: fixed; bottom: 0"
      @click="handleConfirm"
    >确定</van-button>
  </SwipeDialog>
</template>

<script>
import DoctorList from '@/components/DoctorTargetList.vue';
import GbaDoctorList from '@/views/gba/list.vue';
import SwipeDialog from '@/views/layout/swipeDialog';
import {Button} from 'vant';
import Vue from 'vue';
import { isGBA } from '@/utils/index';

Vue.use(Button);

export default {
  components: {
    DoctorList,
    GbaDoctorList,
    SwipeDialog,
  },
  props: {
    multipleMode: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      selectedList: [],
      tabIndex: 0,
    };
  },
  computed: {
    selectedIdList() {
      return this.selectedList.map((item) => item.physician_id);
    },
    currentListComponent() {
      return isGBA() ? 'GbaDoctorList' : 'DoctorList';
    },
  },
  methods: {
    handleConfirm() {
      this.$emit('select', this.selectedList);
    },
    handleSelectItem(item) {
      const id = item.physician_id;

      if (this.multipleMode) {
        const selectedIndex = this.selectedList.findIndex(
          (item) => item.physician_id === id,
        );

        if (selectedIndex > -1) {
          this.selectedList.splice(selectedIndex, 1);
        } else {
          this.selectedList.push(item);
        }
      } else {
        this.selectedList = [item];
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
